import { render } from "./ListUsuario.vue?vue&type=template&id=ab6ccfba"
import script from "./ListUsuario.vue?vue&type=script&lang=js"
export * from "./ListUsuario.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__